import { render, staticRenderFns } from "./PrivacyAgreement.vue?vue&type=template&id=2a88a234&scoped=true"
import script from "./PrivacyAgreement.vue?vue&type=script&lang=js"
export * from "./PrivacyAgreement.vue?vue&type=script&lang=js"
import style0 from "./PrivacyAgreement.vue?vue&type=style&index=0&id=2a88a234&prod&scoped=true&lang=css"
import style1 from "./PrivacyAgreement.vue?vue&type=style&index=1&id=2a88a234&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_efc848e9267e82724df6d0a8b137201b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a88a234",
  null
  
)

export default component.exports